export const ADMIN_ROLE_ADMIN = 'admin';
export const ADMIN_ROLE_TICKET_CHECKIN = 'ticket_checkin';

const LOGIN_PATHS = new Set(['/adminlogin', '/sp-login']);

export const getAdminRole = () =>
  localStorage.getItem('adminRole') || ADMIN_ROLE_ADMIN;

export const getAdminUsername = () => localStorage.getItem('adminUsername') || '';

export const isAdminAuthenticated = () =>
  localStorage.getItem('isAuthenticated') === 'true';

export const isTicketCheckInOnly = () =>
  getAdminRole() === ADMIN_ROLE_TICKET_CHECKIN;

export const setAdminSession = ({ role, username }) => {
  localStorage.setItem('isAuthenticated', 'true');
  localStorage.setItem('adminRole', role || ADMIN_ROLE_ADMIN);
  if (username) {
    localStorage.setItem('adminUsername', username);
  }
};

export const clearAdminSession = () => {
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('adminRole');
  localStorage.removeItem('adminUsername');
};

const normalizePath = (pathname) => (pathname || '').toLowerCase();

export const isAdminLoginPath = (pathname) =>
  LOGIN_PATHS.has(normalizePath(pathname));

export const isPathAllowedForAdminRole = (pathname, search = '', role) => {
  const path = normalizePath(pathname);

  if (isAdminLoginPath(path)) {
    return true;
  }

  if (role === ADMIN_ROLE_TICKET_CHECKIN) {
    if (path === '/admincheckin') {
      return true;
    }
    if (path === '/adminticketdashboard') {
      const tab = new URLSearchParams(search).get('tab');
      return !tab || tab === 'checkin';
    }
    return false;
  }

  return true;
};

export const getDefaultAdminPath = (role) =>
  role === ADMIN_ROLE_TICKET_CHECKIN ? '/AdminCheckIn' : '/AdminHomePage';
